import React, { Component } from 'react';

import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Fab,
  Button,
} from '@material-ui/core';
import {
  ExitToApp as ExitToAppIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
} from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';

import { openSnackbar } from '../../components/Notifier';
import AddNewPartnerDialog from './dialogs/AddNewPartnerDialog';
import CreateVirtualTransactionDialog from './dialogs/CreateVirtualTransactionDialog';
import VirtualTransactionJsonDialog from './dialogs/VirtualTransactionJsonDialog';
import NettingDialog from './dialogs/NettingDialog';
import WalletColumn from './components/WalletColumn';
import WalletsDuck from '../../ducks/WalletsDuck';
import AuthDuck from '../../ducks/AuthDuck';
import NettingDuck from '../../ducks/NettingDuck';

const styles = (theme) => ({
  root: {},
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  appBarTitle: {
    marginRight: theme.spacing.unit * 4,
  },
  grow: {
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
    marginTop: '63px',
    padding: theme.spacing.unit * 3,
    minHeight: 'calc(100vh - 63px)',
    overflow: 'auto',
  },

  partnerRow: {
    position: 'relative',
    whiteSpace: 'nowrap',
  },
  addPartnerFab: {
    position: 'fixed',
    top: `calc(64px + ${2 * theme.spacing.unit}px)`,
    right: `${2 * theme.spacing.unit}px`,
    zIndex: 1000,
  },
  card: {
    width: '200px',
  },
});

class TransfersPage extends Component {
  state = {
    addPartnerModalOpen: false,
  };

  componentDidMount() {
    this.props.loadWallets(this.props.token);
  }

  openAddPartnerModal = () => {
    this.setState({
      addPartnerModalOpen: true,
    });
  };

  closeAddPartnerModal = () => {
    this.setState({
      addPartnerModalOpen: false,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            <Typography
              variant="h6"
              color="inherit"
              className={classes.appBarTitle}
            >
              Transfer Demo
            </Typography>
            <Button color="inherit" onClick={this._startNetting}>
              Start Netting
            </Button>
            <div className={classes.grow} />
            <IconButton color="inherit" onClick={this._reset}>
              <DeleteIcon />
            </IconButton>
            <IconButton color="inherit" onClick={this._logout}>
              <ExitToAppIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <main className={classes.content}>
          <div className={classes.partnerRow}>
            <Fab
              className={classes.addPartnerFab}
              color="primary"
              onClick={this.openAddPartnerModal}
            >
              <AddIcon />
            </Fab>
            {this.props.wallets.map((wallet) => (
              <WalletColumn
                key={wallet.walletId}
                wallet={wallet}
                numberOfRows={Math.max(
                  10,
                  this.props.numberOfVirtualTransactions,
                )}
              />
            ))}
          </div>
        </main>
        <AddNewPartnerDialog
          open={this.state.addPartnerModalOpen}
          onClose={this.closeAddPartnerModal}
        />
        <CreateVirtualTransactionDialog
          open={this.props.isCreateVirtualTransactionModalOpen}
        />
        <NettingDialog open={this.props.isNettingDialogOpen} />
        <VirtualTransactionJsonDialog
          open={this.props.isVirtualTransactionJsonDialogOpen}
        />
      </div>
    );
  }

  _logout = () => {
    this.props.logout(this.props.email);
    openSnackbar({ message: 'Bye!' });
  };

  _reset = () => {
    const { token } = this.props;
    this.props.deleteVirtualTransactions({ token }).then(() => {
      openSnackbar({ message: 'Virtual Transactions removed!' });
    });
  };

  _startNetting = () => {
    const { token } = this.props;
    this.props.startNetting({ token });
  };
}

const mapStateToProps = (state) => {
  return {
    email: state.auth.email,
    token: state.auth.token,
    wallets: state.wallets.wallets,
    numberOfVirtualTransactions: state.wallets.numberOfVirtualTransactions,
    isCreateVirtualTransactionModalOpen:
      state.virtualTransaction.isShowVirtualTransactionModal,
    isNettingDialogOpen: state.netting.isNettingDialogOpen,
    isVirtualTransactionJsonDialogOpen:
      state.virtualTransactionJson.isShowVirtualTransactionJsonModal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadWallets: (token) => {
      return dispatch(WalletsDuck.creators.loadWallets(token));
    },
    logout: (email) => {
      return dispatch(AuthDuck.creators.logout(email));
    },
    startNetting: ({ token }) => {
      return dispatch(NettingDuck.creators.startNetting({ token }));
    },
    deleteVirtualTransactions: ({ token }) => {
      return dispatch(
        WalletsDuck.creators.deleteVirtualTransactions({ token }),
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(TransfersPage));
